module.exports = __webpack_public_path__ + "static/media/car_parking.a6391d8b.svg";